/**
 * 
 * @version 1.0
 * @author Shihj
 * @description 工具类模块
 * -----2018-8-3--------------------------------------------------------
 * 
 * **/



export default {
  /**
   * 验证码倒计时
   * **/
  settime(val, time, type) {
    var newTime = time;
    if (type) {
      setInterval(() => {
        if (time == 0) {
          val.removeAttribute("disabled");
          val.innerHTML = "获取验证码";
          time = newTime;
          type = false;
        } else {
          if (type) {
            val.setAttribute("disabled", true);
            val.innerHTML = "重新发送(" + time + ")";
            time--;
          }
        }
      }, 1000)
    }

  },

  /**
   * 电话格式
   * **/
  isTelephone(str) {
    if (/^1[3|4|5|7|8]\d{9}$/.test(str)) {
      return true;
    }
    return false;
  },
  /***
   * 时间格式化
   * 
   * ****/
  formateDate(date, fmt) {
    let o = {
      "M+": date.getMonth() + 1, //月份
      "d+": date.getDate(), //日
      "h+": date.getHours(), //小时
      "m+": date.getMinutes(), //分
      "s+": date.getSeconds(), //秒
      "q+": Math.floor((date.getMonth() + 3) / 3), //季度
      "S": date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (let k in o)
      if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
  },
}



// WEBPACK FOOTER //
// ./src/assets/js/tool.js